import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "drv-form-root" }
const _hoisted_2 = { class: "drv-text-body-md drv-text-weight-medium" }
const _hoisted_3 = { class: "form-wrapper row drv-gap-4 drv-my-1-5 drv-py-2" }
const _hoisted_4 = { class: "drv-py-2" }

import { computed, ref } from "vue";
import {
  EAuthTypes,
  ECommonMessages,
  ETelematicsMessagesKeys,
  IPlatform,
  ITrimbleBasic,
} from "../../../../types";
import { Input } from "draivn-ui-kit/components/input";
import {
  maxLengthValidator,
  minLengthValidator,
  requiredValidator,
} from "draivn-ui-domain";
import HelpLink from "@/modules/onboarding/components/blocks/telematics/HelpLink.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'TrimbleBasic',
  props: {
    modelValue: {},
    platform: {},
    disable: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

const emit =
  __emit;

const EMPTY_MODEL: ITrimbleBasic = { type: EAuthTypes.BASIC, customerId: "" };

const model = computed<ITrimbleBasic>({
  get() {
    return props.modelValue ?? EMPTY_MODEL;
  },
  set(value: ITrimbleBasic) {
    emit("update:modelValue", value);
  },
});

const usernameModel = computed<string>({
  get() {
    return props.modelValue?.customerId ?? EMPTY_MODEL.customerId;
  },
  set(value: string) {
    model.value = { ...model.value, customerId: value };
  },
});

const nameControl = ref<typeof Input | null>(null);
const hasError = computed<boolean>(() => {
  return !usernameModel.value || (nameControl.value?.hasError ?? false);
});

__expose({
  hasError,
});

return (_ctx: any,_cache: any) => {
  const _component_d_input = _resolveComponent("d-input")!
  const _component_d_snackbar = _resolveComponent("d-snackbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t(_unref(ETelematicsMessagesKeys).TRIMBLE_BASIC_TITLE)), 1),
      _createVNode(HelpLink, {
        link: _ctx.$t(_unref(ETelematicsMessagesKeys).TRIMBLE_INSTRUCTIONS_URL)
      }, null, 8, ["link"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_d_input, {
        ref_key: "nameControl",
        ref: nameControl,
        class: "drv-form-control-adaptive",
        modelValue: usernameModel.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((usernameModel).value = $event)),
        disable: _ctx.disable,
        "lazy-rules": "",
        "label-slot": "",
        label: _ctx.$t(_unref(ETelematicsMessagesKeys).TRIMBLE_BASIC_USERNAME_TITLE),
        rules: [
          _unref(requiredValidator)(_ctx.$t(_unref(ECommonMessages).REQUIRED_ERROR)),
          _unref(maxLengthValidator)(
            100,
            _ctx.$t(_unref(ECommonMessages).MAX_LENGTH_ERROR, { length: 100 })
          ),
          _unref(minLengthValidator)(
            2,
            _ctx.$t(_unref(ECommonMessages).MIN_LENGTH_ERROR, { length: 2 })
          ),
        ]
      }, null, 8, ["modelValue", "disable", "label", "rules"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_d_snackbar, {
        icon: "triangle-exclamation",
        class: "drv-bg-color-b100 drv-color-b600",
        message: _ctx.$t(_unref(ETelematicsMessagesKeys).TRIMBLE_BASIC_APPROVAL_NOTE)
      }, null, 8, ["message"])
    ])
  ]))
}
}

})